<template>
    <header id="cover text-white">
        <div class="pattern"></div>
        <div class="video-container">
            <video
                id="vid"
                class="hero-video-file"
                autoplay="autoplay"
                muted="muted"
                loop="loop"
                autobuffer
                poster="~@/assets/img/header-background.png"
            >
                <source
                    id="mp4"
                    src="~@/assets/img/header-background.mp4"
                    type="video/mp4"
                />
            </video>
        </div>
        <div class="inside text-center" :class="{ hideit: scrolled }">
            <!-- <img
                class="headerlogo animate__animated animate__fadeIn"
                src="~@/assets/img/header-logo.png"
                alt=""
            /> -->
            <p
                class="text-huge openSans text-bold p2 animate__animated animate__fadeIn"
            >
                Você sabe o que é LGPD?
            </p>
            <span>
                <p class="p3 subtitle animate__animated animate__fadeIn animate__delay-500ms">
                    LGPD é a legislação brasileira que
                    <span class="text-bold"
                        >regula as atividades de tratamento de dados
                        pessoais</span
                    >, como nome, endereço, e-mail, idade, estado civil e
                    situação patrimonial.
                </p>
                <p
                    class="text-big openSans text-bold smTitle animate__animated animate__fadeIn animate__delay-1s"
                >
                    Qual o impacto disso para o RH?
                </p>
                <p class="p2 animate__animated animate__fadeIn animate__delay-2s">
                    É o que vamos ver a seguir.
                </p>
            </span>
        </div>
    </header>
</template>

<script>
export default {
    props: ["scrolled"],
    methods: {
        hideCursor() {
            this.showCursor = false;
            // console.log("GOT HERE");
        },

        scrollHeader() {
            // console.log("SCROLL = ", window.pageYOffset);
            if (window.pageYOffset > 2000) {
                document.querySelector(".inside").style.display = "none";
            } else {
                document.querySelector(".inside").style.display = "block";
            }
        },
    },
    created() {
        if (
            navigator.userAgent.indexOf("MSIE") !== -1 ||
            navigator.appVersion.indexOf("Trident/") > -1
        ) {
            window.addEventListener("scroll", this.scrollHeader);
        }
    },
};
</script>

<style lang="scss" scoped>
.hideit {
    opacity: 0;
}
header {
    background-image: url("~@/assets/img/header-background.png");
    background-attachment: fixed;
    background-size: cover;
    width: 100%;
    height: 100vh;

    .animate__animated.animate__delay-500ms {
        -webkit-animation-delay: .5s;
        animation-delay: .5s;
        -webkit-animation-delay: var(--animate-delay);
        animation-delay: var(--animate-delay);
    }

    .first-text {
        padding-bottom: 10px;
    }
    .subtitle {
        max-width: 600px;
        line-height: 35px;
    }
    .smTitle {
        padding-top: 50px;
    }
    .text {
        &-big {
            font-size: 2rem;
            font-family: "Open Sans";
        }
    }
    .pattern {
        position: absolute;
        border: 0px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.25);
        background-image: radial-gradient(#000 5%, transparent 35%);
        background-size: 3px 3px;
        z-index: 3;
        height: 100vh;
    }
    .video-container {
        overflow: hidden;
        z-index: 2;
        pointer-events: none;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 100vh;
    }
    .hero-video-file {
        // left: 50%;
        // position: absolute;
        // top: 50%;
        // transform: translate(-50%, -50%);
        // width: 177.77777778vh; /* 100 * 16 / 9 */
        // min-width: 100%;
        // min-height: 56.25vw; /* 100 * 9 / 16 */
        // max-height: 768px;
        box-sizing: border-box;
        height: 56.25vw;
        left: 50%;
        min-height: 100%;
        min-width: 100%;
        transform: translate(-50%, -50%);
        position: absolute;
        top: 50%;
        width: 177.77777778vh;
    }
    .inside {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 3;
        transition: 1s;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: left;
        color: white;
        max-width: 1132px;
        width: 1132px;
        height: 100vh;

        .title {
            font-size: 2.5rem;
        }
        .typing {
            background-color: $color-cerulean;
        }
        .highlight {
            background-color: $color-cerulean;
        }
        .type-2 {
            visibility: hidden;
        }
    }
    .text-padding-top {
        padding-top: 10px;
    }

    .letsgo {
        width: 280px;
        text-align: center;
        margin-top: 20px;
        padding: 5px;
    }
    @media (max-width: 1336px) {
        .inside {
            max-width: 1000px;
            width: 1000px;
        }
    }

    @media (max-width: 1100px) {
        .inside {
            max-width: 850px;
            width: 850px;
        }
    }
    @media (max-width: 1100px) {
        .smTitle {
            padding: 20px 0 0 0;
        }
        .text-huge {
            font-size: 2rem;
        }
        .inside {
            max-width: 90%;
        }
    }
    @media (max-height: 580px) {
        .headerlogo {
            display: none;
        }
        .inside {
            top: 55%;
        }
    }
}
</style>